import 'bootstrap-select'
import 'bootstrap-select/sass/bootstrap-select.scss'

$('#gann-selectpicker-products').change(function() {
    window.location.href = '#' + this.value;
    if (window.plausible) {
        plausible('Downloads: Product Search', {props: {product: this.innerText}});
    }
});
